import type { AnonymousUser, User } from './user.types';

export const isJaneUser = (user?: User | AnonymousUser): user is User =>
  !!user?.authenticated;
